import { IGetUsuarioByIdUseCase } from "../../../presentation/useCases/read/get_usuario_by_id_use_case";
import { Usuario } from "../../models/usuario";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * GetUsuarioByIdUseCase
 */

export class GetUsuarioByIdUseCase implements IGetUsuarioByIdUseCase {
  constructor(private readonly repository: IAdministracaoRepository) { }

  async execute(idUsuario: number): Promise<Usuario> {
    const usuario = await this.repository.getUsuarioById(idUsuario);
    return usuario;
  }

}
